// @flow
import AssignTaskOperatorsModalContainer from './AssignTaskOperatorsModalContainer';
import type { Operator, Task } from './AssignTaskOperatorsModal';

export default AssignTaskOperatorsModalContainer;
export type { Operator, Task };
